"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
const partnerLogos = [{
  name: "Apex Gaming",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_apex_gaming.png"
}, {
  name: "DR Gaming Technology",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_dr_gaming.png"
}, {
  name: "Apex Gaming SK",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_apex_sk.png"
}, {
  name: "Apogee Gaming",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_apogee_gaming.png"
}, {
  name: "Global Tech",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_global_tech.png"
}, {
  name: "Casino Solutions",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_casino_solutions.png"
}, {
  name: "Innovation Systems",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_innovation_systems.png"
}, {
  name: "Elite Gaming",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/partner_elite_gaming.png"
}];
export default function GlobalFitnessPartners() {
  return <section data-section-id="222165" id="global-synergy" className="bg-background py-12 md:py-16 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-center text-2xl md:text-3xl font-default font-bold text-secondary tracking-widest mb-8 md:mb-10 uppercase">
          Our Global Partners
        </h2>

        <Carousel opts={{
        loop: true,
        align: "start",
        dragFree: true
      }} className="w-full">
          <CarouselContent className="-ml-4 md:-ml-8 items-center">
            {partnerLogos.map((logo, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-8 basis-1/3 sm:basis-1/4 md:basis-1/5 lg:basis-1/6">
                <div className="flex items-center justify-center p-4 h-[120px] bg-white border border-border rounded-lg shadow-sm transition-shadow duration-300 hover:shadow-md">
                  <img src={logo.src} alt={`${logo.name} logo`} className="max-h-12 w-auto object-contain grayscale opacity-60 transition-all duration-300 hover:grayscale-0 hover:opacity-100" loading="lazy" />
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}